export default __webpack_public_path__ + "static/media/portfolio-155.cd68958c.jpg";